import React, { Component } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

import Loading from "../../assets/icons/Loading.gif";
import "./style.css";

export default class CustomLoader extends Component {
  render() {
    const { text = "Please wait" } = this.props;

    return (
      <div className="loader-container-backdrop fade-in">
        <div className="loader-container bounce-in">
          <p>{text}</p>
          <img src={Loading} alt="loading" />
        </div>
      </div>
    );
  }
}
